var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSofa3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 13C9 12.4477 9.44772 12 10 12H18C18.5523 12 19 12.4477 19 13V15C19 15.5523 18.5523 16 18 16H10C9.44772 16 9 15.5523 9 15V13Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04716 4.93222C2.7518 3.41528 3.88135 2 5.3874 2C6.52505 2 7.50454 2.82481 7.72765 3.97068L8.10869 5.92767C8.42132 7.53327 8.67225 9.14993 8.86113 10.7739C8.05302 11.1881 7.5 12.0295 7.5 13V15C7.5 16.3807 8.61929 17.5 10 17.5H18C19.0953 17.5 20.0262 16.7956 20.3641 15.815C20.7591 16.2594 21 16.8508 21 17.5C21 18.8807 19.9103 20 18.5661 20H18V21C18 21.5523 17.5523 22 17 22C16.4477 22 16 21.5523 16 21V20H8V21C8 21.5523 7.55228 22 7 22C6.44772 22 6 21.5523 6 21V20H6.42331C5.31874 20 4.42331 19.1046 4.42331 18V17.1967C4.42331 13.7407 4.09097 10.2931 3.43112 6.90422L3.04716 4.93222Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofa3);
export default __webpack_public_path__ + "static/media/sofa-3.e5dd0a6496bc0a950125325ea2afeccc.svg";
export { ForwardRef as ReactComponent };